<template id="modal-template">
  <div class="modal-mask" @click="handleClickOutside" transition="modal">
    <div class="modal-wrapper" ref="modalWrapper">
      <div class="modal-video">
        <a
          class="modal-close modal-close--video"
          @click="close"
        ><i class="icon icon--cross"></i><span class="sr-only">Close</span></a>
        <div class="text-center w-100">
          <slot name="body"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import useGlobalStore from '../../store/globalStore'

const globalStore = useGlobalStore()
const modalWrapper = ref(null)

const close = () => {
  globalStore.setModal({
    name: '',
    id: '',
  })
}

const handleClickOutside = (event) => {
  if (modalWrapper.value && !modalWrapper.value.contains(event.target)) {
    close()
  }
}
</script>
